import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function BedroomsPage() {
    const { t } = useTranslation();
    const directory= "/images/bedrooms/";
    const filenames=[
        'VPR02436_Vasso_Paraschi.webp',
        'VPR02449_Vasso_Paraschi.webp',
        'VPR02452_Vasso_Paraschi.webp',
        'VPR02723_Vasso_Paraschi.webp',
        'VPR02726_Vasso_Paraschi.webp',
        'VPR02766_Vasso_Paraschi.webp',
        'VPR02835_Vasso_Paraschi.webp',
        'VPR03025_Vasso_Paraschi.webp',
        'VPR03043_Vasso_Paraschi.webp',
        'VPR03049_Vasso_Paraschi.webp',
        'VPR03062_Vasso_Paraschi.webp',
        'VPR03079_Vasso_Paraschi.webp',
        'VPR03335_Vasso_Paraschi.webp',
        'VPR03359_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Bedrooms")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default BedroomsPage;
